var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"modal-wrapper"},[_c('div',{staticClass:"modal__header"},[_vm._t("header")],2),_vm._v(" "),_c('div',{staticClass:"modal__body"},[_vm._t("body")],2),_vm._v(" "),_c('div',{staticClass:"modal__footer"},[_vm._t("footer")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }